{
  "common": {
    "goBackA11y": "Go back",
    "tryAgainLater": "Please try again later.",
    "free": "Free",
    "plus": "Plus",
    "currentPlan": "Current plan",
    "manageOnWeb": "Manage your payment method from Opncue on the web."
  },
  "features": {
    "free": {
      "cues": "5 Cues per day",
      "conversations": "Unlimited conversations",
      "groups": "Unlimited group participation",
      "deck": "Limited conversation deck",
      "practice": "Conversation Practice through Practice Packs",
      "goals": "3 active goals",
      "reflections": "3 reflections per month",
      "mood": "Mood Jar and monthly Vibe Card",
      "progressCard": "One standard Progress Card",
      "safety": "All safety tools"
    },
    "plus": {
      "everythingInFree": "Everything in Free",
      "cues": "10 Cues per day",
      "deck": "Full conversation deck library",
      "practice": "100 AI practice responses per month",
      "feedback": "Detailed practice feedback",
      "goals": "10 active goals",
      "reflections": "Unlimited reflections",
      "dashboard": "Full progress dashboard",
      "history": "Complete history and trends",
      "customisation": "Progress Card customisation",
      "export": "Progress export"
    }
  },
  "subscription": {
    "title": "Subscription",
    "updatedTitle": "Payment method updated",
    "updatedBody": "Your card has been saved.",
    "loadError": "Couldn’t load subscription",
    "cancelError": "Couldn’t cancel",
    "resumeError": "Couldn’t resume",
    "freeTitle": "You’re on the Free plan",
    "freeBody": "Upgrade to Opncue Plus for more cues, more starts, and more room to connect.",
    "seePlans": "See plans",
    "current": "Current subscription",
    "perYear": "per year",
    "perMonth": "per month",
    "endsOn": "Your plan ends on {{date}}. You won’t be charged again.",
    "nextBilling": "Your next billing date is {{date}}.",
    "resume": "Resume subscription",
    "cancel": "Cancel subscription",
    "paymentMethod": "Payment method",
    "card": "Card",
    "expires": "Expires {{month}}/{{year}}",
    "noCard": "No card on file.",
    "updatePayment": "Update payment method",
    "addPayment": "Add payment method",
    "cancelTitle": "Cancel subscription?",
    "cancelBody": "You’ll keep Opncue Plus until the end of your current billing period, then move to Free. You can resume anytime before then.",
    "keepPlus": "Keep Plus",
    "trialBadge": "Free trial",
    "trialConverts": "Your free trial ends on {{date}}. You will be charged {{amount}} {{interval}} from then, unless you cancel before.",
    "trialCancelled": "Your free trial ends on {{date}}. You will not be charged.",
    "cancelTrialTitle": "Cancel free trial?",
    "cancelTrialBody": "You will keep Opncue Plus until your trial ends, and you will not be charged. You can resume anytime before then.",
    "cancelTrialConfirm": "Cancel trial",
    "storeTitle": "Managed by the App Store",
    "storeTitleAndroid": "Managed by Google Play",
    "storeAccessUntil": "Your Plus access runs to {{date}}.",
    "storeBody": "You subscribed through the app store, so your price, renewal date and cancellation are handled there. Changes you make show up here automatically.",
    "storeManage": "Manage in the App Store",
    "storeManageAndroid": "Manage on Google Play",
    "storeOpenError": "Couldn’t open the store"
  },
  "pricing": {
    "title": "Plus",
    "intro": "Plans designed around real connection, not more people to browse.",
    "monthly": "Monthly",
    "annual": "Annual",
    "perYear": "{{price}}/year",
    "perMonth": "{{price}}/month",
    "freeDescription": "Start making intentional connections nearby.",
    "plusDescription": "More room to practise, reflect, and look back on your progress.",
    "grantActive": "Your Plus access is active.",
    "grantActiveUntil": "Your Plus access runs until {{date}}.",
    "cancel": "Cancel",
    "upgrade": "Upgrade",
    "activeTitle": "You’re on Opncue Plus",
    "activeBody": "Thanks for supporting Opncue. Your plan is active.",
    "paymentError": "Payment didn’t work",
    "unavailableTitle": "Not available yet",
    "unavailableBody": "Subscriptions are not available on this platform yet.",
    "priceUnavailable": "Price unavailable"
  },
  "checkout": {
    "confirmingTitle": "Confirming your payment",
    "confirmingBody": "Checking with our payment provider…",
    "successTitle": "Payment successful",
    "practiceReplies_one": "You now have {{count}} practice reply.",
    "practiceReplies_other": "You now have {{count}} practice replies.",
    "purchaseConfirmed": "Your purchase is confirmed.",
    "plusActive": "Thanks for supporting Opncue. Opncue Plus is now active.",
    "cancelledTitle": "Payment not completed",
    "cancelledBody": "No charge was made. You can try again whenever you’re ready.",
    "unverifiedTitle": "Payment not confirmed",
    "unverifiedBody": "We couldn’t confirm a completed payment. If you were charged, your balance will update shortly.",
    "backHome": "Back to home",
    "returning": "Returning to home in {{count}}s",
    "tryAgain": "Try again"
  },
  "checkoutPage": {
    "title": "Configure your plan",
    "planLabel": "Choose your plan",
    "planMonthly": "Plus monthly",
    "planAnnual": "Plus annual",
    "billedMonthly": "Billed monthly",
    "billedYearly": "Billed yearly",
    "paymentLabel": "Payment method",
    "summaryTitle": "Opncue Plus",
    "subtotal": "Subtotal",
    "tax": "Tax",
    "total": "Total due today",
    "totalInclTax": "Total due today (incl. tax)",
    "perMonth": "month",
    "perYear": "year",
    "renewNote": "Your subscription renews automatically at {{price}} per {{interval}} until you cancel.",
    "consent": "I agree to be charged the amount above now and on a recurring basis until I cancel. I can cancel anytime in settings.",
    "subscribe": "Subscribe and pay",
    "previewError": "Couldn’t load pricing. Please try again.",
    "startError": "Couldn’t start your subscription. Please try again."
  },
  "card": {
    "notConfigured": "Card management isn’t configured yet.",
    "startError": "Couldn’t start card setup. Please try again.",
    "setupFailed": "Card setup failed. Please try again.",
    "setupIncomplete": "Card setup didn’t complete. Please try again.",
    "genericError": "Something went wrong. Please try again.",
    "save": "Save card"
  },
  "provider": {
    "paymentFailed": "Payment didn’t work. Please try again later.",
    "purchasesUnavailable": "In-app purchases aren’t available in this build yet."
  },
  "trial": {
    "startCta": "Start free trial",
    "pricingNote": "Try Plus free for {{days}} days — {{zero}} today, then {{price}} per {{interval}} starting {{date}}. Cancel anytime.",
    "thenNote": "Then {{price}} per {{interval}} starting {{date}}. Cancel anytime before then and you won't be charged.",
    "gateCta": "Try Plus free for {{days}} days"
  }
}
